// Sentry configuration for the application
export const sentryConfig = {
  // DSN configuration
  dsn: 'https://d95e611f9c80d030e6e3bf3d3878c4ef@o4508991676678144.ingest.us.sentry.io/4508991678447616',

  // Environment detection
  environment: import.meta.env.MODE || 'development',

  // Sampling rates optimized for free plan
  tracesSampleRate: 0.1, // 10% of transactions
  replaysSessionSampleRate: 0.01, // 1% of sessions
  replaysOnErrorSampleRate: 0.1, // 10% of error sessions

  // Performance optimization
  maxBreadcrumbs: 50,
  attachStacktrace: false,

  // Debug mode
  debug: import.meta.env.DEV,

  // Integrations configuration
  integrations: [
    // Browser tracing with reduced overhead
    {
      name: 'browserTracing',
      options: {
        startTransactionOnLocationChange: false,
        startTransactionOnPageLoad: true,
        // Only trace important routes
        routingInstrumentation: (routingContext) => {
          const { location } = routingContext;
          // Don't trace static assets or common routes
          if (
            location.pathname.includes('/static/') ||
            location.pathname.includes('/assets/')
          ) {
            return false;
          }
          return true;
        },
      },
    },
    // Session replay with privacy protection
    {
      name: 'replay',
      options: {
        maskAllText: true,
        blockAllMedia: true,
        networkDetailAllowUrls: [],
        networkDetailDenyUrls: ['*'],
        // Only capture replays for errors
        sessionSampleRate: 0.01,
        errorSampleRate: 0.1,
      },
    },
  ],

  // Error filtering
  beforeSend: (event, hint) => {
    const error = hint.originalException;

    // Filter out common browser errors
    const ignoredErrors = [
      'Network Error',
      'Failed to fetch',
      'ResizeObserver loop limit exceeded',
      'Script error.',
      'Script error',
      'Uncaught ReferenceError: $ is not defined',
      'Uncaught ReferenceError: jQuery is not defined',
    ];

    if (ignoredErrors.some((msg) => error?.message?.includes(msg))) {
      return null;
    }

    // Filter out browser extension errors
    if (
      error?.stack?.includes('chrome-extension://') ||
      error?.stack?.includes('moz-extension://') ||
      error?.stack?.includes('safari-extension://')
    ) {
      return null;
    }

    // Filter out common React development errors
    if (import.meta.env.DEV && error?.message?.includes('React')) {
      return null;
    }

    return event;
  },

  // Release tracking
  release: '1.0.0',

  // Tags for better organization
  initialScope: {
    tags: {
      app: 'coin-circle-trust',
      version: '1.0.0',
    },
  },
};

// Error categories for better filtering
export const errorCategories = {
  API: 'api_error',
  AUTH: 'auth_error',
  VALIDATION: 'validation_error',
  NAVIGATION: 'navigation_error',
  RENDERING: 'rendering_error',
  NETWORK: 'network_error',
  UNKNOWN: 'unknown_error',
};

// Performance thresholds
export const performanceThresholds = {
  SLOW_TRANSACTION: 3000, // 3 seconds
  VERY_SLOW_TRANSACTION: 10000, // 10 seconds
  SLOW_API_CALL: 2000, // 2 seconds
  VERY_SLOW_API_CALL: 5000, // 5 seconds
};

export default sentryConfig;
